import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	pageTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	pageTitle: {
		id: 'directories.boards-v2.page.page-title',
		defaultMessage: 'Boards',
		description: 'Boards directory page title',
	},
});
export default messages;
